
import * as api from '../api'

export function fetchRemoteData ({ dispatch, state }) {
    if(!state.trainers) dispatch('loadTrainers')
    if(!state.favourites) dispatch('loadFavourites')
}

export async function loadTrainers ({commit}) {
    try {
        const response = await api.trainers()
        commit('setTrainers', response.data.data)
    } catch(error) {
        console.error(error)
    }
}

export async function loadFavourites ({commit}) {
    try {
        const response = await api.workout.all({params: {favourited_by: 'me'}})
        commit('setFavourites', response.data.data)
    } catch(error) {
        console.error(error)
    }
}

export function setWindowHeight () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function checkIfMobileNav ({commit, state}) {
    const windowWidth = window.innerWidth
    commit('setMobileNav', windowWidth < state.breakpoints.tabletLandscape)
}

export function checkIfNotebook ({commit, state}) {
    const windowWidth = window.innerWidth;
    if(windowWidth < state.breakpoints.ipadPro) {
        commit('setNotebook', false)
    } else {
        commit('setNotebook',  windowWidth > state.breakpoints.tabletLandscape && windowWidth < state.breakpoints.notebook)
    }
}